/**
 * Culinary Trails: Local Vendors (Trail Stops).
 *
 * @category   JavaScript
 * @subpackage CulinaryTrailsAssetsManager
 * @author     Jason D. Moss <jason@jdmlabs.com>
 * @copyright  2017 Taste of Nova Scotia. All rights reserved.
 * @link       https://novascotiaculinarytrails.com/
 */


/**
 *
 */
window.addEventListener("load", function () {
    "use strict";

    var target = document.querySelector(".local-vendors > div");

    /**
     * Round up/down number.
     *
     * @param {Float}|{Integer} number
     * @param {Integer}         precision
     *
     * @returns {Float}|{Integer}
     */
    var roundDistance = function (number, precision) {
        var factor = Math.pow(10, precision);
        var tempNumber = number * factor;
        var roundedTempNumber = Math.round(tempNumber);

        return roundedTempNumber / factor;
    };


    /**
     * ...
     *
     * @param {Object} vendors
     *
     * @returns {void}
     */
    var displayLocalVendors = function (vendors) {
        [].slice.call(vendors).reverse().map(function (vendor, index) {
            /**
             * Calculate proximity.
             */
            var distance = roundDistance(vendor.distance, 2) * 1000;

            var vendorCard = document.createElement("figure");
            var vendorImage = document.createElement("img");
            var vendorCaption = document.createElement("figcaption");
            var vendorTitle = document.createElement("h5");
            var vendorCity = document.createElement("p");
            var vendorProximity = document.createElement("p");
            var vendorProfile = document.createElement("a");

            vendorImage.src = vendor.image;
            vendorImage.alt = vendor.name;

            vendorCard.className = "local-vendor";
            vendorTitle.className = "name";
            vendorCity.className = "city";
            vendorProximity.className = "distance";

            vendorProfile.className = "profile";
            // vendorProfile.href = "/trail-stop/"+ vendor.slug;

            if ( $('body').hasClass('lang--fr') ) {
                vendorProfile.href = "/fr/trail-stop/"+ vendor.slug;
                vendorProfile.innerHTML = "LEn savoir plus &#187;";
            }
            else {
                vendorProfile.href = "/trail-stop/"+ vendor.slug;
                vendorProfile.innerHTML = "Learn more &#187;";
            }
            

            var vendorName = document.createTextNode(vendor.name);
            vendorTitle.appendChild(vendorName);

            var vendorCityText = document.createTextNode(vendor.city);
            vendorCity.appendChild(vendorCityText);

            var approxDistance = document.createTextNode("Approx. "+ distance +" meters");
            vendorProximity.appendChild(approxDistance);

            vendorCaption.appendChild(vendorTitle);
            // vendorCaption.appendChild(vendorCity);
            vendorCaption.appendChild(vendorProximity);
            vendorCaption.appendChild(vendorProfile);

            vendorCard.appendChild(vendorImage);
            vendorCard.appendChild(vendorCaption);

            target.parentNode.insertBefore(vendorCard, target);
            target.parentNode.insertBefore(vendorCard, target.nextSibling);
        });
    };

    if (exists(localVendors)) {
        displayLocalVendors(localVendors);
    }
});

/* -- */
